import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

export const notificationsRoutes: RouteRecordRaw[] = [
  {
    path: routes.NOTIFICATIONS,
    name: 'NOTIFICATIONS',
    component: () => import('./NotificationsPage.vue'),
    meta: { requiresAuth: true, title: 'Notifications' },
  },
]
